module.exports = __webpack_public_path__ + "img/form.3aefb1e5.svg";